<template>
    <el-form label-position="left" :model="formData" ref="ruleForm" :rules="rules" @validate="handleValidate"  label-width="120px">
        <FormGroup>检查</FormGroup>
        <el-form-item label="执行时间" class="label-required">
            <div slot="label" class="inline-block">
                执行时间
                <el-tooltip  effect="dark" content="在指定的时间内触发检查与操作，指定时间外的时间不会检查与操作" placement="top-start">
                    <i class="el-icon-question pointer"/>
                </el-tooltip>
            </div>
            <el-radio-group v-model="formData.check_type" @change="changeCheckType" :disabled="isView">
                <el-radio-button label="1">不限</el-radio-button>
                <el-radio-button label="2">指定时间</el-radio-button>
            </el-radio-group>
        </el-form-item>

        <el-form-item label="" prop="execute_time_frequency" v-if="formData.check_type=='2'">
            <el-select v-model="formData.execute_time_frequency" @change="changeExecuteTimeFrequency" :disabled="isView" placeholder="请选择" style="width: 150px;" class="mr20">
                <el-option label="按星期" value="1"></el-option>
                <el-option label="工作日" value="2"></el-option>
                <el-option label="非工作日" value="3"></el-option>
                <el-option label="周末" value="4"></el-option>
                <el-option label="节假日" value="5"></el-option>
            </el-select>

            <el-checkbox-group v-if="formData.execute_time_frequency=='1'" v-model="formData.weeks" :disabled="isView" class="inline-block">
                <el-checkbox label="1">星期一</el-checkbox>
                <el-checkbox label="2">星期二</el-checkbox>
                <el-checkbox label="3">星期三</el-checkbox>
                <el-checkbox label="4">星期四</el-checkbox>
                <el-checkbox label="5">星期五</el-checkbox>
                <el-checkbox label="6">星期六</el-checkbox>
                <el-checkbox label="7">星期日</el-checkbox>
            </el-checkbox-group>

            <el-checkbox-group v-if="formData.execute_time_frequency=='5'" v-model="formData.holidays" :disabled="isView" class="inline-block">
                <el-checkbox label="22">元旦</el-checkbox>
                <el-checkbox label="11">春节</el-checkbox>
                <el-checkbox label="44">清明节</el-checkbox>
                <el-checkbox label="55">劳动节</el-checkbox>
                <el-checkbox label="66">端午节</el-checkbox>
                <el-checkbox label="77">中秋节</el-checkbox>
                <el-checkbox label="88">国庆节</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="" props="start_end_time" v-if="formData.check_type=='2'">
            <el-time-select
                style="width:150px;"
                class=""
                @change="changeStartTime"
                placeholder="起始时间"
                v-model="formData.execute_time_start"
                :disabled="isView"
                :picker-options="{ start: '00:00',step: '01:00',end: '23:00',}">
            </el-time-select>
            <span class="ml10 mr10 font12px text-color-normal">至</span>
            <el-time-select
                style="width:150px;"
                placeholder="结束时间"
                @change="changeEndTime"
                v-model="formData.execute_time_end"
                :disabled="isView"
                :picker-options="{start: '01:00',step: '01:00',end: '24:00',minTime:formData.execute_time_start}">
            </el-time-select>
        </el-form-item>

        <el-form-item label=" 检查频次" prop="check_frequency_time" class="label-required">
            <el-radio-group value="2" :disabled="isView">
                <!--<el-radio-button label="1">≈30分钟一次</el-radio-button>-->
                <el-radio-button label="2">指定时间</el-radio-button>
            </el-radio-group>
            <div class="mt10">
                <DropTimes v-model="formData.check_frequency_time" :weekDate="appointedTime" :disabled="isView"/>
            </div>

        </el-form-item>
    </el-form>
</template>

<script>
    import FormGroup from '../formGroup';
    import dayjs from 'dayjs';
    import SelectAll from '../selectAll.vue';
    import DropTimes from '../../components/dropTimes.vue';

    export default {
        name: "CheckInfo",
        components:{
            FormGroup,
            SelectAll,
            DropTimes
        },
        inject:['appointed_time','validFormItem','isView'],
        data(){
            let _this = this;
            const validTimeFrequency = (rule, value, callback) =>{
                if(_this.formData.check_type=='1'){
                    callback();
                }else{
                    if(_this.formData.execute_time_frequency=='1'&&_this.formData.weeks.length<=0){
                        callback(new Error('请选择星期'));
                    }else if(_this.formData.execute_time_frequency=='5'&&_this.formData.holidays.length<=0){
                        callback(new Error('请选择节假日'));
                    }else{
                        callback();
                    }
                }
            };
            const validStartEndTime = (rule, value, callback) =>{
                if(_this.formData.execute_time_start&&!_this.formData.execute_time_end){
                    callback(new Error('请选择结束时间'));
                }else{
                    callback();
                }
            };
            const validFrequencyTime = (rule, value, callback) =>{
                if(!_this.formData.execute_time_start&&!_this.formData.execute_time_end){
                    callback();
                }else{
                    let today = dayjs().format('YYYY-MM-DD');
                    let start = dayjs(today+' '+_this.formData.execute_time_start+':00');
                    let end = dayjs(today+' '+_this.formData.execute_time_end+':00');
                    let errTimes = [];
                    let checkedTimes = _this.formData.check_frequency_time;
                    checkedTimes.forEach(item=>{
                        if(dayjs(today+' '+item+':00').isBefore(dayjs(start))||dayjs(today+' '+item+':00').isAfter(dayjs(end))){
                            errTimes.push(item);
                        }
                    });

                    if(errTimes.length>0){
                        callback(new Error(`检查频次【${errTimes.join('/')}】未在设置的执行时间【${_this.formData.execute_time_start}-${_this.formData.execute_time_end}】之内`));
                    }else{
                        callback();
                    }
                }
            };
            return {
                formData:{
                    check_type:'1',
                    weeks:['1','2','3','4','5','6','7'],
                    holidays:['22','11','44','55','66','77','88'],
                    execute_time_frequency:'-1',
                    execute_time_frequency_data:[],
                    execute_time_start:'',
                    execute_time_end:'',
                    check_frequency_time:[],
                },
                rules:{
                    execute_time_frequency:[
                        { required:true, validator: validTimeFrequency, trigger: 'change' },
                    ],
                    check_frequency_time:[
                        { type: 'array', required: true, message: '请至少选择一个指定时间', trigger: 'change' },
                        { required:true, validator: validFrequencyTime, trigger: 'change' },
                    ],
                    start_end_time:[
                        { required:true, validator: validStartEndTime, trigger: 'change' },
                    ],
                },
            }
        },
        watch: {
            'formData.check_frequency_time': {
                handler(n) {
                    this.$refs.ruleForm.validateField(['check_frequency_time']);
                },
                deep: true
            }
        },
        computed:{
            appointedTime(){
                return this.appointed_time();
            },
            appointedTimeList(){
                let list = this.appointedTime||[];
                return list.map(item=>{
                    return {
                        id:item,
                        name:item,
                    }
                })
            }
        },
        
        methods:{
            setFormData(data){
                console.log('setFormData',data);

                this.formData.check_type = data.execute_time_frequency=='-1'?'1':'2';    // 1-不限 2-指定时间
                this.formData.execute_time_frequency = data.execute_time_frequency;
                if(data.execute_time_frequency=='1'){
                    this.formData.weeks = (data.execute_time_frequency_data||'').split('');
                }else if(data.execute_time_frequency=='5'){
                    this.formData.holidays = (data.execute_time_frequency_data||'').split(',');
                }
                this.formData.execute_time_start = data.execute_time_start;
                this.formData.execute_time_end = data.execute_time_end=='00:00'?'24:00':data.execute_time_end;
                this.formData.check_frequency_time = (data.check_frequency_time||"").split(',');
            },
            handleValidate(key, valid, info){
                const data = {
                    execute_time_frequency: '检查-执行时间',
                    check_frequency_time: '检查-检查频次',
                    start_end_time: '检查-执行时间',
                };
                if (!valid) {
                    this.validFormItem(`${data[key]}：${info}`);
                }
            },
            changeCheckType(val){
                if(val==='1'){
                    this.formData.execute_time_frequency = '-1';
                    this.formData.execute_time_start = '';
                    this.formData.execute_time_end = '';
                }else{
                    this.formData.execute_time_frequency = '1';     // 默认选星期
                    this.formData.weeks = ['1','2','3','4','5','6','7'];
                }
            },
            changeExecuteTimeFrequency(val){
                console.log('changeExecuteTimeFrequency',val);
            },
            changeStartTime(){
                this.formData.execute_time_end = '';
                if(this.formData.check_frequency_time.length>0){
                    this.$refs.ruleForm.validateField('check_frequency_time');
                }
            },
            changeEndTime(){
                if(this.formData.check_frequency_time.length>0){
                    this.$refs.ruleForm.validateField('check_frequency_time');
                }
            },
            changeCheckFrequencyTime(val){
                if(val.includes('all-option')){
                    this.formData.check_frequency_time = this.appointedTime.map(item=>item);
                }else{
                    this.formData.check_frequency_time = val;
                }
            },
            // 获取表单数据
            async validateFn() {
                const valid = await this.$refs.ruleForm.validate();
                if (valid) {
                    return {...this.formData}
                }
            },
        },

    }
</script>

<style scoped>

</style>
